import axios from 'axios'
import authentication from './authentication';
import router from "../router";

const api = axios.create({
    baseURL: process.env.VUE_APP_ORBITER_API_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})

api.interceptors.request.use(
    config => {
        const token = localStorage.getItem("orbiter_jwt");
        if (token) {
            config.headers.common["Authorization"] = "Bearer " + token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    response => {
        if (response.status === 500) {
            return Promise.reject(response);
        } else {
            return Promise.resolve(response);
        }
    },
    error => {
        if (error.response.status) {
            switch (error.response.status) {
                case 403:
                    authentication.logout();
                    router.push('/');
                    break;
            }
        }
        return Promise.reject(error);
    }
);

export default api;